import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import {NavigationEnd, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {Meta} from '@angular/platform-browser';
import {ScriptService} from "@summit/nav";

@Component({
  selector: 'profile-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public environment = environment;
  public appTitle: string;
  public isStrippedDownHeader: boolean = true;
  private unsubscribe$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private meta: Meta,
    private scriptService: ScriptService
  ) {
  }

  public ngOnInit(): void {

    /**
     * This code adds specific meta tags given the app is on some kind of test environment.
     * All off the NonTestServers are listed in the ScriptService if you need to add or modify at some point.
     */
    const SERVER_NAME = this.scriptService.getServerName(true);

    if (!this.scriptService.getNonTestServers().includes(SERVER_NAME)) {

      // Test CSP should be stored as a string in the environment variables
      // this.meta.addTag({httpEquiv: 'Content-Security-Policy', content: environment.csp});

      // This prevents tracking on test servers
      this.meta.addTag({name: 'robots', content: 'noindex,nofollow'});
    }
    /** ------------------------------------------------------------------ **/

      // monitor for route changes and sync the app header with the route name
    const routerEvent$: Observable<any> = this.router.events;

    routerEvent$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(event => {
      if (event instanceof NavigationEnd) {
        const urlParts: string[] = event.url.split(/[/,?]+/);
        const currentRoute: string = urlParts[1];
        if (currentRoute === 'new') {
          this.appTitle = 'Request a Login';
        } else {
          this.appTitle = 'User Profile';
          this.isStrippedDownHeader = false;
        }
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  public ngOnDestroy(event?): void {
    this.unsubscribe$.next(true);
  }

}

